// Global state store
import { reactive } from 'vue';

// Create reactive store
const store = reactive({
  balance: 0,
  clickPower: 1,
  energyCurrent: 1000,
  energyMax: 1000,
  autoTapLevel: 0,
  totalClicks: 0,
  totalCoinsEarned: 0,
  boostActive: false,
  boostExpireAt: null,
  lastEnergyUpdate: Date.now()
});

// Methods to update store
export const updateBalance = (newBalance) => {
  store.balance = newBalance;
  // Also save to localStorage for persistence
  if (typeof window !== 'undefined') {
    localStorage.setItem('astro_local_balance', newBalance.toString());
  }
};

export const updateGameState = (newState) => {
  Object.assign(store, newState);
  // Save to localStorage
  if (typeof window !== 'undefined') {
    const stateToSave = {
      balance: store.balance,
      clickPower: store.clickPower,
      energyCurrent: store.energyCurrent,
      energyMax: store.energyMax,
      autoTapLevel: store.autoTapLevel,
      totalClicks: store.totalClicks,
      totalCoinsEarned: store.totalCoinsEarned,
      boostActive: store.boostActive,
      boostExpireAt: store.boostExpireAt,
      lastEnergyUpdate: store.lastEnergyUpdate
    };
    localStorage.setItem('astroGameState', JSON.stringify(stateToSave));
  }
};

export const loadStoreFromLocalStorage = () => {
  if (typeof window === 'undefined') return;
  
  // Load balance
  const savedBalance = localStorage.getItem('astro_local_balance');
  if (savedBalance) {
    store.balance = parseInt(savedBalance) || 0;
  }
  
  // Load game state
  const savedState = localStorage.getItem('astroGameState');
  if (savedState) {
    try {
      const state = JSON.parse(savedState);
      Object.assign(store, state);
    } catch (e) {
      console.error('Failed to load game state:', e);
    }
  }
};

// Export the store
export default store;